'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Bot } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'

export function AgentList() {
  const t = useTranslations('home_v3.agent_list')
  const AGENTS = [
    {
      id: 'business-plan',
      href: '/chatkit/business-plan',
      image: '/images/ai-team-ceo.png',
      title: t('business_plan_agent'),
      description: t('business_plan_description'),
    },
    {
      id: 'ebook-generator',
      href: '/chatkit/ebook-generator',
      image: '/images/ai-team-copywriter.png',
      title: t('ebook_writing_agent'),
      description: t('ebook_writing_description'),
    },
    {
      id: 'blog-generator',
      href: '/chatkit/blog-generator',
      image: '/images/ai-team-brand.png',
      title: t('blog_agent'),
      description: t('blog_description'),
    },
    {
      id: 'market-research',
      href: '/chatkit/market-research',
      image: '/images/ai-team-seo.png',
      title: t('marketing_research_agent'),
      description: t('marketing_research_description'),
    },
    {
      id: 'design',
      href: '/chatkit/design',
      image: '/images/ai-team-designer.png',
      title: t('visual_design_agent'),
      description: t('visual_design_description'),
    },
    {
      id: 'business-naming',
      href: '/chatkit/business-naming-agent',
      image: '/images/business-naming-agent.png',
      title: t('business_naming_agent'),
      description: t('business_naming_description'),
      className: 'p-0',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 min-[1800px]:grid-cols-5 gap-4">
      {AGENTS.map((agent) => (
        <Link
          key={agent.id}
          href={agent.href}
          className="w-full text-left h-full flex"
        >
          <div className="rounded-xl transition-all duration-200 bg-gradient-to-br from-white/5 via-white/5 to-white/[0.02] backdrop-blur-md hover:from-white/8 hover:via-white/8 hover:to-white/5 hover:scale-[1.02] overflow-hidden shadow-lg shadow-black/20 hover:shadow-xl hover:shadow-black/30 flex flex-col w-full h-[320px]">
            <div className="relative flex-shrink-0">
              <div className="w-full aspect-video rounded-t-lg overflow-hidden bg-gradient-to-br from-purple-500/10 to-indigo-600/10 flex items-center justify-center">
                <Image
                  src={agent.image}
                  alt={agent.title}
                  width={864}
                  height={720}
                  className={cn(
                    'w-full h-full object-contain transition-all duration-300',
                    agent.className || '',
                  )}
                />
              </div>
            </div>
            <div className="px-6 py-4 flex-1 flex flex-col justify-center min-h-[80px]">
              <h3 className="text-white font-semibold text-base mb-1 leading-tight line-clamp-1">
                {agent.title}
              </h3>
              <p className="text-gray-400 text-sm font-normal leading-tight line-clamp-2">
                {agent.description}
              </p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}
